<div id="logManager"></div>
